import React from 'react';

import cx from 'classnames';
import { useSelector } from 'react-redux';

import Button from 'components/shared/Button';
import Icon from 'components/shared/Icon';
import RightFill from 'components/shared/Icon/icons/RightFill';
import Visibility from 'components/shared/Icon/icons/Visibility';
import ColHeader from 'components/shared/Table/ColHeader';
import colHeaderStyles from 'components/shared/Table/ColHeader/index.module.css';
import { isAgentSelector } from 'store/user/selectors';

import styles from './index.module.css';

const withColHeaderWrapper = (title, orderBy, order, onOrder) => (tableInst) => (
  <ColHeader title={title} orderBy={orderBy} order={order} onOrder={onOrder} {...tableInst} />
);

const getColumns = ({ params, onEdit, onOrder, onView }) => {
  const getOrderedColHeader = (name) => withColHeaderWrapper(name, params.orderBy, params.order, onOrder);

  return [
    {
      Header: getOrderedColHeader('Property Name'),
      accessor: 'name',
      Cell: ({ row, cell }) => {
        const iconClasses = row?.isExpanded ? colHeaderStyles.iconRotateDown : '';

        return (
          <span {...row.getToggleRowExpandedProps()} className={styles.tdWithIcon}>
            <Icon
              component={RightFill}
              className={cx(colHeaderStyles.icon, colHeaderStyles.collapsed, iconClasses)}
              width="6"
              height="12"
            />
            {cell.value}
          </span>
        );
      },
    },
    {
      Header: getOrderedColHeader('Portfolio'),
      accessor: 'portfolio',
    },
    {
      Header: getOrderedColHeader('Country'),
      accessor: 'country',
      Cell: ({ row }) => <>{row.original?.area?.country?.name}</>,
    },
    {
      Header: getOrderedColHeader('Area'),
      accessor: 'area',
      Cell: ({ row }) => <>{row.original?.area?.name}</>,
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) => {
        const isCanUpdate = row?.original?.policies?.update;
        const isAgent = useSelector(isAgentSelector);

        return (
          <div className={styles.container}>
            {isAgent ? (
              <Icon
                component={Visibility}
                width="1.6rem"
                fill="#3F3C43"
                onClick={() => onView(row.original?.pageId)}
                disabled={!row?.original?.policies?.show}
              />
            ) : (
              <Button type="default" size="small" onClick={() => onEdit(row.original?.pageId)} disabled={!isCanUpdate}>
                Edit
              </Button>
            )}
          </div>
        );
      },
    },
  ];
};

export default getColumns;
